import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    transition: 'all 300ms ease',
    transitionDelay: 1500,
    position: 'relative',
    zIndex: 9999,
  },
  rootLoaded: {
    opacity: 0,
    visibility: 'hidden',
    zIndex: -1,
  },
  bg: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    height: '100%',
    width: '100%',
    transform: 'translate(0, 0)',
    transition: 'all 500ms ease',
  },
  bgLoaded: {
    transform: 'translate(0, calc(-100%))',
  },
  logo: {
    width: '100px',
    height: 'auto',
    position: 'fixed',
    left: 0,
    top: 0,
    transition: 'all 0.2s ease',
    transform: 'translate(calc(50vw - 70px), calc(50vh - 36px)) scale(1.5)',
    [theme.breakpoints.down('sm')]: {
      width: 90,
      height: 25,
      transform: 'translate(calc(50vw - 45px), calc(50vh - 12px)) scale(1.5)',
    },
  },
  logoLoaded: {
    visibility: 'hidden',
  },
}))

export default styles
